import { render, staticRenderFns } from "./commonDialog.vue?vue&type=template&id=55715d15&scoped=true"
import script from "./commonDialog.vue?vue&type=script&lang=js"
export * from "./commonDialog.vue?vue&type=script&lang=js"
import style0 from "./commonDialog.vue?vue&type=style&index=0&id=55715d15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55715d15",
  null
  
)

export default component.exports